module.exports = __webpack_public_path__ + "img/full-vefman.cd9f3ec7.svg";